/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/internalPortalMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a InternalPortal. */
export class InternalPortal {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a InternalPortal.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Retrieves feature flags for the current user.
   * @summary Retrieves feature flags for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.InternalPortalGetFeatureFlagsResponse>
   */
  getFeatureFlags(options?: coreHttp.RequestOptionsBase): Promise<Models.InternalPortalGetFeatureFlagsResponse>;
  /**
   * @param callback The callback
   */
  getFeatureFlags(callback: coreHttp.ServiceCallback<Models.PublicFeatureFlags>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getFeatureFlags(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.PublicFeatureFlags>): void;
  getFeatureFlags(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.PublicFeatureFlags>, callback?: coreHttp.ServiceCallback<Models.PublicFeatureFlags>): Promise<Models.InternalPortalGetFeatureFlagsResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getFeatureFlagsOperationSpec,
      callback) as Promise<Models.InternalPortalGetFeatureFlagsResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getFeatureFlagsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/InternalPortal/featureflags",
  responses: {
    200: {
      bodyMapper: Mappers.PublicFeatureFlags
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
